import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

// Logo now renders the full brand mark (which already contains the "more me"
// wordmark inside the SVG), so we don't double-up with a separate Typography.
// Bump size so it's prominent at boot on mobile.
const Logo = styled('img')({
  width: 180,
  height: 180,
  maxWidth: '60vw',
  maxHeight: '60vw',
  objectFit: 'contain',
  animation: 'loadingPulse 2s ease-in-out infinite',
});

interface LoadingScreenProps {
  mesaira?: string;
  size?: 'small' | 'medium' | 'large';
}

function LoadingScreen({ mesaira = 'Loading...', size = 'medium' }: LoadingScreenProps) {
  const getSize = () => {
    switch (size) {
      case 'small':  return 32;
      case 'large':  return 64;
      default:       return 48;
    }
  };

  return (
    <LoadingContainer>
      <style>{`
        @keyframes loadingPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.04); opacity: 0.92; }
        }
      `}</style>
      <LogoContainer>
        <Logo
          src={`${process.env.PUBLIC_URL}/brand/moreme-logo.svg`}
          alt="MoreMe AI"
          onError={(e) => {
            // Fall back to PNG if the SVG fails for any reason.
            const el = e.target as HTMLImageElement;
            if (!el.src.endsWith('logo512.png')) el.src = `${process.env.PUBLIC_URL}/logo512.png`;
          }}
        />
      </LogoContainer>

      <CircularProgress size={getSize()} thickness={4} sx={{ mb: 2 }} />

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textAlign: 'center', maxWidth: 300 }}
      >
        {mesaira}
      </Typography>
    </LoadingContainer>
  );
}

export default LoadingScreen;